import { render, staticRenderFns } from "./UpgradeSessionDetails.vue?vue&type=template&id=8d7f55ee&scoped=true&lang=pug"
import script from "./UpgradeSessionDetails.vue?vue&type=script&lang=js"
export * from "./UpgradeSessionDetails.vue?vue&type=script&lang=js"
import style0 from "./UpgradeSessionDetails.vue?vue&type=style&index=0&id=8d7f55ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7f55ee",
  null
  
)

export default component.exports